import React, { useEffect } from "react";
import "../panchangam/panchangam.css";
import "./homeNews.css";
import { Box, Grid, Typography } from "@mui/material";
import { logEvent } from "../../../../utils/analytics";
import TitleBox from "../../../../components/common/titleBox/TitleBox";
import { useNewsMasterHook } from "../../customHooks";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

function News(props) {
  const { news, fetchNews } = useNewsMasterHook();
  const navigate = useNavigate();
  useEffect(() => {
    fetchNews();
  }, []);

  return (
    <TitleBox
      title={<Box class='panchang-title'>
        <Typography variant="h6" component="div">
               News
             </Typography>
             </Box>}
      buttonLabel={'View All'}
      buttonLink={'/news'}
      content={
        <React.Fragment>
          <Grid className="panchang-content2">
            <Box
              sx={{
                p: 3,
                maxHeight: "400px",
                overflowY: "auto",
                width: "100%",
              }}
            >
              {news &&
                news.map((item, i) => (
                  <Box sx={{ p: 3 }} key={i}>
                    <Grid className="content-algn">
                      <Typography variant="p" className="news-title1">
                        {item?.date}
                      </Typography>
                      <Typography variant="p">
                        <Grid className="mb-3">
                          <Grid>
                            <Typography variant="p" className="news-title">
                              {item?.title}
                            </Typography>
                            <div>
                              <img
                                src={item?.image}
                                alt={item?.title}
                                className="news-title-img"
                              />
                            </div>
                            <div
                              className="news-desc"
                              dangerouslySetInnerHTML={{
                                __html: item?.description,
                              }}
                            />

                            <Button
                              variant="contained"
                              color="primary"
                              className="text-white"
                              onClick={() => {
                                navigate(`/knowmorenews/${item.slug}`);
                                logEvent(
                                  "Home Page News",
                                  "Know more news Clicked",
                                  item.title
                                );
                              }}
                            >
                              Know more
                            </Button>
                          </Grid>
                        </Grid>
                      </Typography>
                    </Grid>
                  </Box>
                ))}
            </Box>
          </Grid>
        </React.Fragment>
      }
    ></TitleBox>
  );
}
export default News;
